import { ChangeEvent, useState } from "react"
import {numerosNaturales} from "../../Utils/regex"

const ContactanosContent = () => {

    const estadoInicial = {
        nombre: "",
        email: "",
        telefono: "",
        preferenciaContacto: "",
        mensaje: ""
    }

    const [infoToSend, setInfoToSend] = useState(estadoInicial)
    const [msgSubmit, setMsgSubmit] = useState("")
    return (
        <>
        <div id="content" className="main-content">
            <div className="layout-px-spacing">
                <div className="contact-us layout-top-spacing">
                    <div className="cu-contact-section">
                        <div id="basic_map1"></div>
                        <div className="contact-form">
                            <form onSubmit={(e) => handleSubmit(e) }>
                                <div className="cu-section-header">
                                    <h4>Contáctanos</h4>
                                    <p>Envíanos tu consulta y te contactáremos a la brevedad posible.</p>
                                </div>
                                <h4 className="mt-2">Envíanos un mensaje</h4>
                                <div className="row mb-3">
                                    <div className="col-sm-12 col-12 input-fields mb-4 mb-sm-0">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-user ml-2 mb-1"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                                        <input 
                                        type="text" 
                                        className="form-control mt-2"
                                         placeholder="Nombre"
                                         value={infoToSend.nombre}
                                         onChange={(e) => handleInfo(e, "nombre")}
                                         />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-sm-12 col-12 input-fields">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-at-sign ml-2 mb-1"><circle cx="12" cy="12" r="4"></circle><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"></path></svg>
                                        <input 
                                        type="text" 
                                        className="form-control mt-2" 
                                        placeholder="Email"
                                        value={infoToSend.email}
                                        onChange={(e) => handleInfo(e, "email")}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-sm-12 col-12 input-fields">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-phone ml-2 mb-1"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                                        <input 
                                        type="text" 
                                        className="form-control mt-2" 
                                        placeholder="Teléfono"
                                        value={infoToSend.telefono}
                                        onChange={(e) => handleInfo(e, "telefono")}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-sm-12 col-12 ml-2">
                                        <p className="">Cómo prefieres que nos contactemos?</p>
                                    </div>
                                    <div className="col-sm-12 col-12 input-fields ml-2">
                                        <div className="n-chk">
                                            <label className="new-control new-radio radio-primary">
                                            <input
                                            type="radio"
                                            className="new-control-input"
                                            name="custom-radio-1" 
                                            onClick={() => handleInfo("email", "preferenciaContacto")}
                                            />
                                            <span className="new-control-indicator"></span>Email
                                            </label>
                                        </div>
                                        <div className="n-chk">
                                            <label className="new-control new-radio radio-primary">
                                            <input 
                                            type="radio" 
                                            className="new-control-input"
                                            name="custom-radio-1"
                                            onClick={() => handleInfo("telefono", "preferenciaContacto")} 
                                             />
                                            <span className="new-control-indicator"></span>Teléfono
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group input-fields">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-mail ml-2 mb-1"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                                            <textarea 
                                            className="form-control mt-2"
                                            id="exampleFormControlTextarea1"
                                            rows={4}
                                            placeholder="Mensaje"
                                            value={infoToSend.mensaje}
                                            onChange={(e) => handleInfo(e, "mensaje")}
                                            />    
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-4">
                                    <div className="col text-sm-left d-flex align-items-center ">
                                        <button className="btn btn-primary mt-2 ml-2">Enviar</button>
                                        <span 
                                            className={`ml-3 d-felx aling-items-center ${msgSubmit.includes("Error")? 
                                            "text-danger"
                                            : "text-success"}`}>
                                            {msgSubmit}
                                        </span>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    ) 



    function handleInfo(e: ChangeEvent<HTMLInputElement| HTMLTextAreaElement>|string, type:"nombre"|"email"|"telefono"|"preferenciaContacto"|"mensaje") {
        setMsgSubmit("")
        if(typeof e === "string"){
            // preferencia de contacto 
            if(type === "preferenciaContacto")
            setInfoToSend({
                ...infoToSend,
                preferenciaContacto: e
            })
        }
        else{
            if(type==="nombre" && e.target.value.length<80){
                setInfoToSend({...infoToSend, nombre: e.target.value})
            }

            if(type==="email" && e.target.value.length<90){
                setInfoToSend({...infoToSend, email: e.target.value})
            }

            if(type==="telefono" && 
            ((numerosNaturales(e.target.value) && e.target.value.length<=13) || e.target.value === ""))
            {
                setInfoToSend({...infoToSend, telefono: e.target.value})
            }

            if(type === "mensaje" && e.target.value.length<1400){
                setInfoToSend({...infoToSend, mensaje: e.target.value})
            }
        }
    }

    function handleSubmit(e: React.FormEvent<HTMLFormElement>){
        e.preventDefault()
        let mensaje = ""
        if(infoToSend.nombre.length<=5){
            mensaje= "Error: El nombre necesita tener al menos 4 caracteres"
        }
        else if(infoToSend.mensaje.length< 20){
            mensaje = " Error: El mensaje necesita tener al menos 20 caracteres"
        }
        else if(!infoToSend.preferenciaContacto){
            mensaje = " Error: Elija una método de contacto"
        }
        else if(infoToSend.preferenciaContacto === "telefono" && infoToSend.telefono.length <5){
            mensaje = "Error: Ingrese un número de teléfono válido"
        }
        else if(infoToSend.preferenciaContacto === "email" && infoToSend.email.length <5){
            mensaje = "Error: Ingrese un correo electrónico de contacto"
        }

        if(mensaje){
            setMsgSubmit(mensaje)
        }
        else{
            /*
            const response = axios.post("", infoToSubmit,headers)
            .then((res: AxiosResponse<ApiResponse<StructureInfoContact>>) => res.data.companion)
            if(response._error){
                setMsgSubmit(`Error: ${response._error}` )
            }else{
                setMsgSubmit("La información se ha enviado")
                setInfoToSend(estadoInicial)
            }
            */
           setMsgSubmit("La información se ha enviado")
           setInfoToSend(estadoInicial)
        }
    }
}



export default ContactanosContent